module.exports = __webpack_public_path__ + "img/rare-1.8e36c1aa.png";